(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtrare-brewing-guide"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('filtrare-brew')) {
  customElements.define('filtrare-brew', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.fb-cards');
      const cards = [...track.children];
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const progress = this.querySelector('[data-progress]');
      const view = this.querySelector('[data-view]');
      let current = 0;
      this.querySelectorAll('.fb-selector,.fb-mobile-tools,.fb-controls').forEach(el => el.hidden = false);
      const update = () => {
        const left = track.getBoundingClientRect().left;
        current = cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(cards[best].getBoundingClientRect().left-left) ? i : best, 0);
        previous.disabled = current === 0;
        next.disabled = current === cards.length-1;
        progress.textContent = progress.dataset.pattern.replace('__current__',current+1);
      };
      const move = delta => {
        const target = cards[Math.max(0,Math.min(cards.length-1,current+delta))];
        track.scrollTo({left:track.scrollLeft+target.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1));
      next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',e=>{
        if (this.dataset.all === 'true' || !matchMedia('(max-width:749px)').matches) return;
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}
      });
      view.addEventListener('click',()=>{
        const all=this.dataset.all!=='true';
        this.dataset.all=String(all);
        view.setAttribute('aria-pressed',String(all));
        view.textContent=all?this.dataset.carouselLabel:this.dataset.allLabel;
        requestAnimationFrame(update);
      });
      this.querySelectorAll('input[type="radio"]:not([data-serving-choice])').forEach(input=>input.addEventListener('change',()=>{
        this.querySelectorAll('[data-recipe]').forEach(el=>el.hidden=el.dataset.recipe!==input.value);
      }));
      this.querySelectorAll('[data-serving-choice]').forEach(input=>input.addEventListener('change',()=>{
        this.querySelectorAll('[data-servings]').forEach(el=>el.hidden=el.dataset.servings!==input.value);
      }));
      this.resizeObserver=new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback(){this.resizeObserver?.disconnect();this.ready=false;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-collab-shop"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){root.querySelectorAll('.fcs__card').forEach(card=>{if(card.dataset.ready)return;card.dataset.ready='true';const native=card.querySelector('[data-variant]'),variants=[...native.options],selectors=[...card.querySelectorAll('.fcs__options [data-option-index]')],button=card.querySelector('[type=submit]');const choices=JSON.parse(native.selectedOptions[0].dataset.options);function sync(){const selected=variants.find(v=>JSON.parse(v.dataset.options).every((x,i)=>x===choices[i]));if(selected)native.value=selected.value;else native.selectedIndex=-1;const available=selected?.dataset.available==='true';button.disabled=!available;button.textContent=available?card.dataset.addLabel:card.dataset.soldOut;card.querySelector('.fcs__price').textContent=selected?.dataset.price||card.dataset.soldOut;selectors.forEach(control=>{const i=Number(control.dataset.optionIndex);if(control.tagName==='SELECT')control.value=choices[i];else{control.querySelector('[data-colour-name]').textContent=choices[i];control.querySelectorAll('button').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.optionValue===choices[i]));b.dataset.unavailable=String(!variants.some(v=>v.dataset.available==='true'&&JSON.parse(v.dataset.options).every((x,j)=>x===(j===i?b.dataset.optionValue:choices[j]))))})}});const image=card.querySelector('.fcs__photo');if(image&&selected?.dataset.image&&card.dataset.followImage==='true'){image.removeAttribute('srcset');image.src=selected.dataset.image;image.alt=selected.dataset.alt}}selectors.forEach(control=>{const i=Number(control.dataset.optionIndex);if(control.tagName==='SELECT')control.addEventListener('change',()=>{choices[i]=control.value;sync()});else control.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{choices[i]=b.dataset.optionValue;sync()}))});native.addEventListener('change',()=>{choices.splice(0,choices.length,...JSON.parse(native.selectedOptions[0].dataset.options));sync()});card.querySelector('.fcs__options').hidden=false;native.hidden=true;card.querySelector('.fcs__native-label').hidden=true;sync()})}init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-image-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filtrare-image-hotspots')) {
    class FiltrareImageHotspots extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-hotspot-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-hotspot-panel]'));
        this.closeButtons = Array.from(this.querySelectorAll('[data-hotspot-close]'));
        this.instruction = this.querySelector('[data-hotspot-instruction]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleButtonClick = (event) => this.toggle(event.currentTarget);
        this.handleCloseClick = () => this.close(true);
        this.handleDocumentClick = (event) => {
          if (!this.contains(event.target)) this.close(false);
        };
        this.handleKeydown = (event) => {
          if (event.key === 'Escape') this.close(true);
        };
        this.handleBlockSelect = (event) => {
          const button = event.target.querySelector('[data-hotspot-button]');
          if (button) this.open(button, false);
        };
        this.handleBlockDeselect = () => this.close(false);
        this.buttons.forEach((button) => button.addEventListener('click', this.handleButtonClick));
        this.closeButtons.forEach((button) => button.addEventListener('click', this.handleCloseClick));
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      disconnectedCallback() {
        this.buttons?.forEach((button) => button.removeEventListener('click', this.handleButtonClick));
        this.closeButtons?.forEach((button) => button.removeEventListener('click', this.handleCloseClick));
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      toggle(button) {
        if (button.getAttribute('aria-expanded') === 'true') {
          this.close(false);
        } else {
          this.open(button, true);
        }
      }

      open(button, allowScroll) {
        const hotspotId = button.dataset.hotspotButton;
        this.close(false);
        button.setAttribute('aria-expanded', 'true');
        const matchingPanels = this.panels.filter((panel) => panel.dataset.hotspotPanel === hotspotId);
        matchingPanels.forEach((panel) => {
          panel.hidden = false;
        });
        if (this.instruction) this.instruction.hidden = true;
        if (allowScroll && this.mobileQuery.matches) {
          const mobilePanel = matchingPanels.find((panel) => panel.classList.contains('filtrare-hotspots__mobile-panel'));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          requestAnimationFrame(() => {
            mobilePanel?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
          });
        }
      }

      close(restoreFocus) {
        const activeButton = this.buttons.find((button) => button.getAttribute('aria-expanded') === 'true');
        this.buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        this.panels.forEach((panel) => {
          panel.hidden = true;
        });
        if (this.instruction) this.instruction.hidden = false;
        if (restoreFocus) activeButton?.focus();
      }
    }

    customElements.define('filtrare-image-hotspots', FiltrareImageHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-offer-dates"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){const el=document.querySelector('.offer-timing');if(!el)return;const end=Date.parse(el.dataset.offerEnd);const start=Date.parse(el.dataset.offerStart);function check(){const now=Date.now();if(now>=end){const main=el.closest('main');if(main){[...main.children].forEach(child=>{if(!child.contains(el))child.hidden=true})}el.querySelector('[data-offer-status]').hidden=true;el.querySelector('[data-offer-expired]').hidden=false}else if(now<start){el.querySelector('[data-offer-status]').textContent='Starts Friday, October 9 · U.S. orders only · Ends October 12, 11:59 p.m. ET'}}check();if(el._timer)clearInterval(el._timer);el._timer=setInterval(check,30000)}init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-offer-shop"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){root.querySelectorAll('[data-offer-variant]').forEach(select=>{if(select.dataset.ready)return;select.dataset.ready='true';const card=select.closest('article'),visual=card.querySelector('.fwo__visual-options'),swatches=[...card.querySelectorAll('[data-swatch-url]')],style=card.querySelector('[data-offer-style]');function update(){const option=select.selectedOptions[0];if(!option)return;card.querySelector('.fwo__price').textContent=option.dataset.price;const image=card.querySelector('.fwo__photo');if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.alt||''}const active=swatches.find(b=>b.dataset.swatchUrl===option.value);if(active){card.querySelector('[data-colour-name]').textContent=active.dataset.colour;if(style)style.value=active.dataset.style}swatches.forEach(b=>{b.setAttribute('aria-pressed',String(b===active));b.hidden=!!style&&b.dataset.style!==style.value})}swatches.forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.swatchUrl;update()}));if(style)style.addEventListener('change',()=>{const current=swatches.find(b=>b.dataset.swatchUrl===select.value);const candidates=swatches.filter(b=>b.dataset.style===style.value&&!b.disabled);const next=candidates.find(b=>b.dataset.colour===current?.dataset.colour)||candidates[0];if(next){select.value=next.dataset.swatchUrl;update()}else{style.value=current.dataset.style}});select.addEventListener('change',update);update();visual.hidden=false;select.hidden=true;card.querySelector('[data-native-label]').hidden=true})}init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-product-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('filtrare-product-cards')) {
  customElements.define('filtrare-product-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('.fpg__card').forEach(card => {
        const native = card.querySelector('[data-variant]');
        if (!native || !native.options.length) return;
        const variants = [...native.options].map(option => ({ option, choices: JSON.parse(option.dataset.options) }));
        const controls = [...card.querySelectorAll('.fpg__options [data-option-index]')];
        const button = card.querySelector('[type="submit"]');
        const form = card.querySelector('form');
        const initial = native.selectedOptions[0] || native.options[0];
        const choices = JSON.parse(initial.dataset.options);
        let selectedVariantId = initial.value;
        const sync = (updateImage = false) => {
          const match = variants.find(v => v.choices.every((value, index) => value === choices[index]));
          const selected = match?.option;
          const variantChanged = selected?.value !== selectedVariantId;
          selectedVariantId = selected?.value;
          if (selected) native.value = selected.value;
          else native.selectedIndex = -1;
          const available = selected?.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? card.dataset.addLabel : selected ? card.dataset.soldOut : card.dataset.unavailable;
          card.querySelector('.fpg__price').textContent = selected?.dataset.price || card.dataset.unavailable;
          controls.forEach(control => {
            const index = Number(control.dataset.optionIndex);
            if (control.tagName === 'SELECT') control.value = choices[index];
            else {
              control.querySelector('[data-colour-name]').textContent = choices[index];
              control.querySelectorAll('button').forEach(swatch => {
                swatch.setAttribute('aria-pressed', String(swatch.dataset.optionValue === choices[index]));
                const availableMatch = variants.some(v => v.option.dataset.available === 'true' && v.choices.every((value, i) => value === (i === index ? swatch.dataset.optionValue : choices[i])));
                swatch.dataset.unavailable = String(!availableMatch);
              });
            }
          });
          const image = card.querySelector('.fpg__photo');
          if (updateImage && variantChanged && image && selected?.dataset.image && card.dataset.followImage === 'true') {
            image.removeAttribute('srcset');
            image.src = selected.dataset.image;
            image.alt = selected.dataset.alt;
          }
          const details = card.querySelector('.fpg__link');
          if (details && selected?.dataset.url) details.href = selected.dataset.url;
        };
        controls.forEach(control => {
          const index = Number(control.dataset.optionIndex);
          if (control.tagName === 'SELECT') control.addEventListener('change', () => { choices[index] = control.value; sync(true); }, { signal });
          else control.querySelectorAll('button').forEach(swatch => swatch.addEventListener('click', () => { choices[index] = swatch.dataset.optionValue; sync(true); }, { signal }));
        });
        native.addEventListener('change', () => {
          if (!native.selectedOptions[0]) return;
          choices.splice(0, choices.length, ...JSON.parse(native.selectedOptions[0].dataset.options));
          sync(true);
        }, { signal });
        form.addEventListener('submit', event => {
          sync();
          if (button.disabled || !native.value) event.preventDefault();
        }, { signal });
        sync();
        card.querySelector('.fpg__options').hidden = false;
        native.hidden = true;
        card.querySelector('.fpg__native-label').hidden = true;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filtrare-product-carousel')) {
    class FiltrareProductCarousel extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.filtrare-carousel');
        this.track = this.querySelector('[data-carousel-track]');
        this.items = Array.from(this.querySelectorAll('[data-carousel-item]'));
        this.buttons = Array.from(this.section?.querySelectorAll('[data-carousel-direction]') || []);
        this.swatches = Array.from(this.querySelectorAll('[data-swatch-token]'));
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        if (!this.track || this.items.length === 0) return;

        this.handleButtonClick = (event) => this.move(event.currentTarget.dataset.carouselDirection);
        this.handleScroll = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.handleSwatchEnter = (event) => {
          if (!this.mobileQuery.matches) this.showSwatchPreview(event.currentTarget);
        };
        this.handleSwatchLeave = (event) => {
          if (!this.mobileQuery.matches) this.clearSwatchPreview(event.currentTarget);
        };
        this.handleSwatchClick = (event) => {
          if (!this.mobileQuery.matches) return;

          event.preventDefault();
          const swatch = event.currentTarget;
          const card = swatch.closest('[data-carousel-item]');
          if (!card) return;

          this.showSwatchPreview(swatch);
          card.querySelectorAll('[data-swatch-token]').forEach((cardSwatch) => {
            cardSwatch.setAttribute('aria-current', cardSwatch === swatch ? 'true' : 'false');
          });

          const mediaLink = card.querySelector('.filtrare-carousel__media-link');
          if (mediaLink && swatch.href) mediaLink.href = swatch.href;
        };

        this.buttons.forEach((button) => button.addEventListener('click', this.handleButtonClick));
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('pointerenter', this.handleSwatchEnter);
          swatch.addEventListener('pointerleave', this.handleSwatchLeave);
          swatch.addEventListener('focus', this.handleSwatchEnter);
          swatch.addEventListener('blur', this.handleSwatchLeave);
          swatch.addEventListener('click', this.handleSwatchClick);
        });
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.buttons?.forEach((button) => button.removeEventListener('click', this.handleButtonClick));
        this.swatches?.forEach((swatch) => {
          swatch.removeEventListener('pointerenter', this.handleSwatchEnter);
          swatch.removeEventListener('pointerleave', this.handleSwatchLeave);
          swatch.removeEventListener('focus', this.handleSwatchEnter);
          swatch.removeEventListener('blur', this.handleSwatchLeave);
          swatch.removeEventListener('click', this.handleSwatchClick);
        });
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      move(direction) {
        const firstItem = this.items[0];
        if (!firstItem) return;

        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap) || 0;
        const step = firstItem.getBoundingClientRect().width + gap;
        const directionMultiplier = direction === 'next' ? 1 : -1;
        const readingDirection = styles.direction === 'rtl' ? -1 : 1;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: step * directionMultiplier * readingDirection,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      showSwatchPreview(swatch) {
        const card = swatch.closest('[data-carousel-item]');
        const token = swatch.dataset.swatchToken;
        if (!card || !token) return;

        card.querySelectorAll('[data-swatch-preview]').forEach((preview) => {
          preview.classList.toggle('is-active', preview.dataset.swatchPreview === token);
        });
      }

      clearSwatchPreview(swatch) {
        const card = swatch.closest('[data-carousel-item]');
        card?.querySelectorAll('[data-swatch-preview]').forEach((preview) => preview.classList.remove('is-active'));
      }

      update() {
        const trackRect = this.track.getBoundingClientRect();
        const visibleItems = this.items.filter((item) => {
          const rect = item.getBoundingClientRect();
          const visibleWidth = Math.min(rect.right, trackRect.right) - Math.max(rect.left, trackRect.left);
          return visibleWidth > rect.width * 0.45;
        });

        const firstVisible = visibleItems[0] || this.items[0];
        const lastVisible = visibleItems[visibleItems.length - 1] || firstVisible;
        const firstIndex = this.items.indexOf(firstVisible);
        const lastIndex = this.items.indexOf(lastVisible);
        const isStatic = this.track.scrollWidth <= this.track.clientWidth + 2;
        const previousButton = this.buttons.find((button) => button.dataset.carouselDirection === 'previous');
        const nextButton = this.buttons.find((button) => button.dataset.carouselDirection === 'next');

        this.section?.classList.toggle('is-static', isStatic);
        if (previousButton) previousButton.disabled = firstIndex <= 0;
        if (nextButton) nextButton.disabled = lastIndex >= this.items.length - 1;
      }
    }

    customElements.define('filtrare-product-carousel', FiltrareProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-recipes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('filtrare-recipes')) {
  customElements.define('filtrare-recipes', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.units = JSON.parse(this.dataset.units);
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.mode = 'scale';
      this.size = '640';
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.choices.forEach(link => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-controls', link.hash.slice(1));
        link.addEventListener('click', event => {
          event.preventDefault();
          this.show(link.dataset.choice, true);
        }, options);
        link.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); link.click(); }
        }, options);
      });
      this.panels.forEach(panel => {
        panel.querySelector('.fr-options').hidden = false;
        panel.addEventListener('change', event => {
          if (event.target.matches('[data-size]')) this.size = event.target.value;
          if (event.target.matches('input[type="radio"]')) this.mode = event.target.value;
          this.update(panel);
          const status = this.querySelector('[data-status]');
          status.textContent = '';
          requestAnimationFrame(() => { status.textContent = status.dataset.message; });
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = this.panels.find(item => item.dataset.panel === event.detail.blockId);
        if (panel) this.show(panel.dataset.panel, false);
      }, options);
      window.addEventListener('hashchange', () => {
        const panel = this.panels.find(item => '#' + item.id === location.hash);
        if (panel) this.show(panel.dataset.panel, false);
      }, options);
      const linked = this.panels.find(panel => '#' + panel.id === location.hash);
      if (this.panels.length) this.show((linked || this.panels[0]).dataset.panel, false);
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    number(value) { return Number(value.toFixed(1)).toLocaleString(document.documentElement.lang || 'en'); }
    volume(ml) {
      let teaspoons = Math.round(ml / 5);
      const cups = Math.floor(teaspoons / 48);
      teaspoons %= 48;
      const fraction = [[36, '¾'], [32, '⅔'], [24, '½'], [16, '⅓'], [12, '¼']].find(part => teaspoons >= part[0]);
      if (fraction) teaspoons -= fraction[0];
      const tablespoons = Math.floor(teaspoons / 3);
      teaspoons %= 3;
      const pieces = [];
      if (cups || fraction) pieces.push((cups || '') + (fraction ? fraction[1] : '') + ' ' + (cups > 1 || (cups === 1 && fraction) ? this.units.cups : this.units.cup));
      if (tablespoons) pieces.push(tablespoons + ' ' + this.units.tbsp);
      if (teaspoons) pieces.push(teaspoons + ' ' + this.units.tsp);
      return pieces.join(' + ');
    }
    show(id, focus) {
      const selected = this.panels.find(panel => panel.dataset.panel === id);
      if (!selected) return;
      this.panels.forEach(panel => {
        panel.hidden = panel !== selected;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.choices.forEach(link => {
        const active = link.dataset.choice === id;
        link.setAttribute('aria-pressed', String(active));
        const label = link.querySelector('.fr-choice-action');
        label.textContent = active ? label.dataset.on : label.dataset.off;
      });
      this.update(selected);
      if (focus) {
        selected.querySelector('h2').focus({ preventScroll: true });
        selected.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
    }
    update(panel) {
      const originalWater = Number(panel.dataset.water);
      if (!(originalWater > 0)) return;
      const sizeControl = panel.querySelector('[data-size]');
      const target = sizeControl ? Number(this.size) : originalWater;
      const factor = target / originalWater;
      const scale = this.mode === 'scale';
      if (sizeControl) sizeControl.value = this.size;
      panel.querySelectorAll('input[type="radio"]').forEach(input => input.checked = input.value === this.mode);
      const coffee = Number(panel.dataset.coffee) * factor;
      panel.querySelector('[data-coffee-output]').textContent = scale ? this.number(coffee) + ' ' + this.units.g : '≈ ' + this.volume(coffee * 3);
      let cumulative = 0;
      const steps = [...panel.querySelectorAll('[data-pour]')];
      steps.forEach((step, index) => {
        const exact = Number(step.dataset.pour) * factor;
        const amount = scale ? (index === steps.length - 1 ? Math.round((target - cumulative) * 10) / 10 : Math.round(exact * 10) / 10) : Math.round(exact / 5) * 5;
        cumulative = Math.round((cumulative + amount) * 10) / 10;
        step.querySelector('[data-add]').textContent = scale ? this.number(amount) + ' ' + this.units.g : '≈ ' + this.volume(amount);
        step.querySelector('[data-total]').textContent = scale ? this.number(cumulative) + ' ' + this.units.g : '≈ ' + this.number(cumulative) + ' ' + this.units.ml;
        const label = step.querySelector('[data-total-label]');
        label.textContent = scale ? label.dataset.scale : label.dataset.cups;
      });
      panel.querySelector('[data-water-output]').textContent = scale ? this.number(cumulative) + ' ' + this.units.g : '≈ ' + this.volume(cumulative);
      panel.querySelector('[data-scale-note]').hidden = !scale;
      panel.querySelector('[data-cups-note]').hidden = scale;
      panel.querySelector('[data-size-note]').hidden = !sizeControl;
      panel.querySelector('[data-scaled-note]').hidden = !sizeControl || target === originalWater;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-studio-journal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('filtrare-studio-journal')) {
  customElements.define('filtrare-studio-journal', class extends HTMLElement {
    connectedCallback() {
      this.chapters = [...this.querySelectorAll('.fsj__chapter')];
      if (!this.chapters.length) return;
      this.links = [...this.querySelectorAll('.fsj__index a')];
      this.range = this.querySelector('.fsj__scrubber');
      this.media = [...this.querySelectorAll('.fsj__media:has(img)')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.motionChanged = () => {
        this.toggleAttribute('data-motion', this.dataset.parallax === 'true' && !this.reduced.matches);
        this.schedule();
      };
      this.links.forEach((link, i) => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.go(i, true);
      }, { signal }));
      if (this.range) {
        this.range.disabled = false;
        this.range.addEventListener('pointerdown', () => { this.dragging = true; }, { signal });
        this.range.addEventListener('input', () => this.go(Number(this.range.value), false), { signal });
        this.range.addEventListener('change', () => {
          this.dragging = false;
          this.go(Math.round(Number(this.range.value)), true);
        }, { signal });
        window.addEventListener('pointerup', () => { this.dragging = false; this.schedule(); }, { signal });
        window.addEventListener('pointercancel', () => { this.dragging = false; this.schedule(); }, { signal });
        this.range.addEventListener('keydown', event => {
          const current = Math.round(Number(this.range.value));
          const targets = { ArrowDown: current + 1, ArrowRight: current + 1, ArrowUp: current - 1, ArrowLeft: current - 1, PageDown: current + 1, PageUp: current - 1, Home: 0, End: this.chapters.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.go(targets[event.key], false);
        }, { signal });
      }
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      this.reduced.addEventListener('change', this.motionChanged);
      this.addEventListener('shopify:block:select', event => {
        const index = this.chapters.findIndex(chapter => chapter === event.target || chapter.contains(event.target));
        if (index >= 0) this.go(index, false);
      }, { signal });
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.header = document.querySelector('.section-header');
      if (this.header) this.observer.observe(this.header);
      this.setAttribute('data-ready', '');
      this.motionChanged();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.reduced?.removeEventListener('change', this.motionChanged);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.removeAttribute('data-ready');
    }
    positions() {
      const configured = parseFloat(this.style.getPropertyValue('--fsj-offset')) || 112;
      const headerHeight = this.header?.getBoundingClientRect().height || 0;
      this.offset = Math.max(configured, headerHeight + 16);
      this.style.setProperty('--fsj-pin-top', `${this.offset}px`);
      return this.chapters.map(chapter => chapter.getBoundingClientRect().top + window.scrollY - this.offset - 20);
    }
    go(value, smooth) {
      const positions = this.positions();
      const clamped = Math.max(0, Math.min(positions.length - 1, value));
      const lower = Math.floor(clamped);
      const upper = Math.min(lower + 1, positions.length - 1);
      const top = positions[lower] + (positions[upper] - positions[lower]) * (clamped - lower);
      window.scrollTo({ top, behavior: smooth && !this.reduced.matches ? 'smooth' : 'instant' });
      this.paintTimeline(clamped);
      this.schedule();
    }
    paintTimeline(value) {
      const active = Math.round(value);
      this.links.forEach((link, i) => {
        if (i === active) link.setAttribute('aria-current', 'step');
        else link.removeAttribute('aria-current');
      });
      if (this.range) {
        if (!this.dragging) this.range.value = value;
        const title = this.chapters[active]?.querySelector('h3')?.textContent.trim() || '';
        this.range.setAttribute('aria-valuetext', `${active + 1} / ${this.chapters.length}: ${title}`);
      }
    }
    update() {
      const positions = this.positions();
      const y = window.scrollY;
      let value = 0;
      for (let i = 0; i < positions.length - 1; i++) {
        if (y >= positions[i]) value = i + Math.max(0, Math.min(1, (y - positions[i]) / Math.max(1, positions[i + 1] - positions[i])));
      }
      this.paintTimeline(value);
      if (!this.hasAttribute('data-motion')) return;
      const height = window.innerHeight;
      this.media.forEach(media => {
        const rect = media.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > height) return;
        const progress = Math.max(-1, Math.min(1, (height / 2 - rect.top - rect.height / 2) / ((height + rect.height) / 2)));
        media.style.setProperty('--fsj-shift', `${(progress * rect.height * .05).toFixed(2)}px`);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-style-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filtrare-style-comparison')) {
    class FiltrareStyleComparison extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[data-panel]');
          if (panel) this.activate(panel.dataset.panel);
        };

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.style));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });

        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.activate(this.dataset.initialStyle);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      activate(style) {
        const activeTab = this.tabs.find((tab) => tab.dataset.style === style);
        if (!activeTab) return;

        this.tabs.forEach((tab) => {
          const active = tab === activeTab;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== style;
        });
      }

      onKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        const nextTab = this.tabs[nextIndex];
        this.activate(nextTab.dataset.style);
        nextTab.focus();
      }
    }

    customElements.define('filtrare-style-comparison', FiltrareStyleComparison);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-style-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('style-feature-switcher')) {
    class StyleFeatureSwitcher extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.styles = [this.dataset.styleA, this.dataset.styleB];
        this.optionName = this.normalize(this.dataset.optionName);
        this.optionPosition = Number(this.dataset.optionPosition || 0);
        this.syncProduct = this.dataset.syncProduct === 'true';
        this.status = this.querySelector('[aria-live]');
        this.variants = this.readVariants();
        this.handleDocumentChange = this.onDocumentChange.bind(this);
        this.handleVariantChange = this.onVariantChange.bind(this);
        this.handlePopState = this.onPopState.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.onTabClick(tab));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event));
        });

        document.addEventListener('change', this.handleDocumentChange);
        document.addEventListener('variant:change', this.handleVariantChange);
        document.addEventListener('product:variant-change', this.handleVariantChange);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        window.addEventListener('popstate', this.handlePopState);
        this.showStyle(this.dataset.initialStyle, false);
        requestAnimationFrame(() => this.syncFromPage());
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleDocumentChange);
        document.removeEventListener('variant:change', this.handleVariantChange);
        document.removeEventListener('product:variant-change', this.handleVariantChange);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('popstate', this.handlePopState);
      }

      normalize(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
      }

      readVariants() {
        const script = this.querySelector('[data-product-variants]');
        if (!script) return [];
        try {
          const variants = JSON.parse(script.textContent || '[]');
          return Array.isArray(variants) ? variants : [];
        } catch (error) {
          return [];
        }
      }

      isKnownStyle(value) {
        return this.styles.includes(this.normalize(value));
      }

      styleFromVariant(variant) {
        if (!variant || !this.optionPosition || !Array.isArray(variant.options)) return '';
        return this.normalize(variant.options[this.optionPosition - 1]);
      }

      variantFromUrl() {
        const variantId = new URL(window.location.href).searchParams.get('variant');
        if (!variantId) return null;
        return this.variants.find((variant) => String(variant.id) === String(variantId)) || null;
      }

      fieldOptionName(field) {
        const explicitName = field.dataset.optionName || field.closest('[data-option-name]')?.dataset.optionName;
        if (explicitName) return this.normalize(explicitName);
        const name = String(field.name || '').replace(/^options\[/, '').replace(/\]$/, '');
        return this.normalize(name);
      }

      fieldStyle(field) {
        if (!field) return '';
        if (field.tagName === 'SELECT') {
          const option = field.options[field.selectedIndex];
          return this.normalize(option?.value || option?.text);
        }
        return this.normalize(field.value || field.dataset.value || field.textContent);
      }

      matchingFields() {
        return Array.from(document.querySelectorAll('select, input[type="radio"]')).filter((field) => {
          if (this.contains(field)) return false;
          const name = this.fieldOptionName(field);
          const positionMatch = this.optionPosition && name === `option${this.optionPosition}`;
          return name === this.optionName || positionMatch;
        });
      }

      selectedStyleFromPage() {
        const fields = this.matchingFields();
        const selectedField = fields.find((field) => field.tagName === 'SELECT' || field.checked);
        const fieldStyle = this.fieldStyle(selectedField);
        if (this.isKnownStyle(fieldStyle)) return fieldStyle;
        const urlStyle = this.styleFromVariant(this.variantFromUrl());
        return this.isKnownStyle(urlStyle) ? urlStyle : '';
      }

      syncFromPage() {
        const style = this.selectedStyleFromPage();
        if (style) this.showStyle(style, true);
      }

      onDocumentChange(event) {
        const field = event.target;
        if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement)) return;
        const name = this.fieldOptionName(field);
        const positionMatch = this.optionPosition && name === `option${this.optionPosition}`;
        if (name !== this.optionName && !positionMatch) return;
        const style = this.fieldStyle(field);
        if (this.isKnownStyle(style)) this.showStyle(style, true);
        requestAnimationFrame(() => this.syncFromPage());
      }

      onVariantChange(event) {
        const variant = event.detail?.variant || event.detail?.data?.variant || event.detail?.selectedVariant;
        const style = this.styleFromVariant(variant);
        if (this.isKnownStyle(style)) {
          this.showStyle(style, true);
          return;
        }
        requestAnimationFrame(() => this.syncFromPage());
      }

      onPopState() {
        requestAnimationFrame(() => this.syncFromPage());
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const panel = event.target.closest('[data-panel]');
        if (panel) this.showStyle(panel.dataset.panel, true);
      }

      onTabClick(tab) {
        const style = tab.dataset.style;
        this.showStyle(style, true);
        if (this.syncProduct) this.selectProductStyle(style);
      }

      onTabKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;
        event.preventDefault();
        this.tabs[nextIndex].focus();
        this.tabs[nextIndex].click();
      }

      selectProductStyle(style) {
        const field = this.matchingFields().find((candidate) => {
          if (candidate.tagName === 'SELECT') {
            return Array.from(candidate.options).some((option) => this.normalize(option.value || option.text) === style);
          }
          return this.fieldStyle(candidate) === style;
        });

        if (!field) return;
        if (field.tagName === 'SELECT') {
          const option = Array.from(field.options).find((item) => this.normalize(item.value || item.text) === style);
          if (!option || field.value === option.value) return;
          field.value = option.value;
          field.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (!field.checked) field.click();
      }

      showStyle(value, animate) {
        const style = this.normalize(value);
        if (!this.isKnownStyle(style)) return;
        if (this.dataset.activeStyle === style) return;

        const update = () => {
          this.dataset.activeStyle = style;
          this.tabs.forEach((tab) => {
            const active = tab.dataset.style === style;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.panel !== style;
          });
          const activeTab = this.tabs.find((tab) => tab.dataset.style === style);
          if (this.status && activeTab) this.status.textContent = `${activeTab.textContent.trim()} features shown`;
        };

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (animate && document.startViewTransition && !reducedMotion) {
          try {
            document.startViewTransition(update);
          } catch (error) {
            update();
          }
        } else {
          update();
        }
      }
    }

    customElements.define('style-feature-switcher', StyleFeatureSwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtrare-style-switcher-standalone"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-style-feature-switcher')) {
    class CollectionStyleFeatureSwitcher extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.styles = [this.dataset.styleA, this.dataset.styleB];

        this.handleClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.showStyle(tab.dataset.style);
        };

        this.handleKeydown = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          this.onTabKeydown(event, tab);
        };

        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[data-panel]');
          if (panel) this.showStyle(panel.dataset.panel);
        };

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.showStyle(this.dataset.initialStyle);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      onTabKeydown(event, tab) {
        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        const nextTab = this.tabs[nextIndex];
        this.showStyle(nextTab.dataset.style);
        nextTab.focus();
      }

      showStyle(style) {
        if (!this.styles.includes(style)) return;

        this.tabs.forEach((tab) => {
          const active = tab.dataset.style === style;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== style;
        });

        const activeTab = this.tabs.find((tab) => tab.dataset.style === style);
        const status = this.querySelector('[aria-live]');
        if (status && activeTab) status.textContent = activeTab.textContent.trim() + ' features shown';
      }
    }

    customElements.define('collection-style-feature-switcher', CollectionStyleFeatureSwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
